import { useIntl } from 'react-intl';

import { IconSearch } from '@xing-com/icons';

import { SearchDropdownItem } from './search-dropdown-item';

export const SearchDropdownList: React.FC = () => {
  const { formatMessage } = useIntl();

  return (
    <>
      <SearchDropdownItem
        itemKey="members"
        icon={IconSearch}
        href="/search/members"
        title={formatMessage({ id: 'SEARCH_DROPDOWN_MEMBERS' })}
        tracking={{ nwt_nav: 'search_member_search' }}
      />
      <SearchDropdownItem
        itemKey="jobs"
        icon={IconSearch}
        href="/jobs/search/ki"
        title={formatMessage({ id: 'SEARCH_DROPDOWN_JOBS' })}
        tracking={{ nwt_nav: 'search_job_search' }}
      />
      <SearchDropdownItem
        itemKey="companies"
        icon={IconSearch}
        href="/search/companies"
        title={formatMessage({ id: 'SEARCH_DROPDOWN_COMPANIES' })}
        tracking={{ nwt_nav: 'search_companies_search' }}
      />
    </>
  );
};
